<template>
    <div class="ele-container ele-address">
        <Header backType="blank" :back="true" @goBack="goBack"></Header>
        <div class="smart-round-head">
            <div class="round-title">选择收货地址</div>
            <div class="ele-search" v-if="!submit && !thirdUserId">
                <div class="smart-search-input smart-city-search-input">
                    <div class="input-city-icon" @click="chooseCity">
                        <div>{{ this.eleCity || "选择城市" }}</div>
                        <van-icon name="arrow-down" />
                    </div>
                    <form action="javascript:return true">
                        <input
                            type="search"
                            @click="goAddressMap"
                            placeholder="请输入收货地址"
                        />
                    </form>
                </div>
            </div>
            <div class="address-card" v-if="!submit && !thirdUserId">
                <div class="card-content">
                    <p>
                        <Svgs name="icondizhi2"></Svgs>
                        {{ eleLocalAdd.addressName ? "当前定位" : "定位失败" }}
                    </p>
                    <p v-if="eleLocalAdd.addressName">
                        {{ eleLocalAdd.addressName }}
                    </p>
                </div>
                <div @click="chooseLocalAdd">
                    <Svgs color="#fff" name="iconjiantou2" />
                </div>
            </div>
        </div>
        <div class="address-container" :style="commStyle">
            <div class="container-title" v-if="!submit && !thirdUserId">
                我的收货地址
            </div>
            <div
                v-for="(item, index) in address"
                :key="index"
                class="address-item"
                @click="chooseAddress(item)"
            >
                <div>
                    <p>{{ item.addressName }}</p>
                    <p>{{ item.pickupLocation }}</p>
                    <p>
                        {{ item.receiverName }}
                        ({{ item.sex ? "女士" : "先生" }})
                        {{ item.receiverTel }}
                    </p>
                </div>
                <div
                    v-if="!eventData.isQuery"
                    @click.stop.prevent="goEditAddress(item)"
                >
                    <Svgs color="#90939A" name="iconbianji"></Svgs>
                </div>
            </div>
            <div v-if="notDeliverableAddressList.length" class="height10"></div>
            <div
                v-if="notDeliverableAddressList.length"
                class="container-title disable"
            >
                以下地址超出配送范围
            </div>
            <div
                v-for="(item, index) in notDeliverableAddressList"
                :key="'disable' + index"
                class="address-item disable"
            >
                <div>
                    <p>{{ item.addressName }}</p>
                    <p>{{ item.pickupLocation }}</p>
                    <p class="disable">
                        {{ item.receiverName }}
                        ({{ item.sex ? "女士" : "先生" }})
                        {{ item.receiverTel }}
                    </p>
                </div>
                <div @click.stop.prevent="goEditAddress(item)">
                    <Svgs color="#90939A" name="iconbianji"></Svgs>
                </div>
            </div>
        </div>
        <div
            class="ele-add-address"
            @click="addAddress"
            v-if="!eventData.isQuery"
            @touchmove.stop.prevent="touchmove($event)"
        >
            <Svgs class="address-edit-icon" color="#fff" name="iconhao"></Svgs>
        </div>
        <SearchCity
            @onOk="cityOk"
            :eleCity="eleCity"
            :cityList="cityList"
            ref="eventCity"
        ></SearchCity>
    </div>
</template>

<script>
import { mapMutations, mapGetters } from "vuex";
import { miceService } from "@/service/miceService.js";
import { colors } from "@/utils/js/colors.js";
export default {
    name: "Address",
    data() {
        return {
            commStyle: {},
            address: [],
            notDeliverableAddressList: [],
            cityList: [],
            submit: false,
        };
    },
    async created() {
        this.cityList = _.cloneDeep(this.eleCityList);
        this.submit = this.$route.query.submit;
        this.thirdUserId = this.$route.query.thirdUserId;
        this.source = this.$route.query.source;
    },
    computed: {
        ...mapGetters([
            "eleAddress",
            "eleLocalAdd",
            "eleCity",
            "eleCityList",
            "eventData",
        ]),
        color() {
            return colors[this.eventData.tenant_code];
        },
    },
    methods: {
        ...mapMutations([
            "SET_ELE_ADDRESS",
            "SET_ELE_EDIT_ADDRESS",
            "ELE_CITY",
            "ELE_REFRESH",
        ]),
        backList() {
            this.$router.back();
        },
        touchmove(event) {
            var _this = this;
            setTimeout(function () {
                var _circle = event.targetTouches[0];
                var creat = document.getElementsByClassName(
                    "ele-add-address"
                )[0];
                var _clientWidth = document.documentElement.clientWidth;
                var _clientHeight = document.documentElement.clientHeight;
                if (_circle.pageX > 28 && _circle.pageX < _clientWidth - 28) {
                    creat.style.left = -28 + _circle.pageX + "px";
                }
                if (_circle.pageY > 28 && _circle.pageY < _clientHeight - 28) {
                    creat.style.top = -28 + _circle.pageY + "px";
                }
            }, 0);
        },
        chooseCity() {
            this.$refs.eventCity.openPop();
        },
        cityOk(city) {
            this["ELE_CITY"](city.txt);
        },
        onLoad() {
            let erestaurantId = this.$route.query.erestaurantId;
            let SourceCode = this.$route.query.sourceCode;
            if(!SourceCode && ['roche'].includes(this.eventData.tenant_code)){
                SourceCode = 'ELE'
            }
            let params = {
                ErestaurantId: erestaurantId,
                ProposalId: this.eventData.proposalId,
                SourceCode: SourceCode,
                latitude: this.eleAddress.latitude,
                longitude: this.eleAddress.longitude,
            };
            miceService.getUserAddress(params).then((res) => {
                if (res && res.success) {
                    let content = res.content.UserAddressListData;
                    this.address = erestaurantId
                        ? content.deliverableAddressList
                        : content.addressList;
                    this.notDeliverableAddressList =
                        content.notDeliverableAddressList || [];
                    (content.notDeliverableAddressList || []).forEach(
                        (item) => {
                            if (item.addressId == this.eleAddress.addressId) {
                                this["SET_ELE_ADDRESS"]({
                                    latitude: this.eleAddress.latitude,
                                    longitude: this.eleAddress.longitude,
                                    addressName: this.eleAddress.addressName,
                                    cityName: this.eleAddress.cityName || ''
                                });
                            }
                        }
                    );
                    (this.address || []).forEach((item) => {
                        if (item.addressId == this.eleAddress.addressId) {
                            this["SET_ELE_ADDRESS"](item);
                        }
                    });
                }
            });
        },
        // 获取饿了么地址接口
        getEleAdd() {
            let params = {
                platform: 5,
                thirdUserId: this.thirdUserId,
            };
            if(['roche'].includes(this.eventData.tenant_code)){
                params.SourceCode = 'ELE'
            }
            miceService.getEleUserAddress(params).then((res) => {
                if (res && res.success) {
                    let content = res.content;
                    this.address = content.addressList;
                }
            });
        },
        // 点击搜索事件
        goAddressMap() {
            this.$router.push(`/ele/addressMap?list=true`);
        },
        // 点击添加地址
        addAddress() {
            this["SET_ELE_EDIT_ADDRESS"]({});
            this.$router.push("/ele/addAddress");
        },
        // 编辑地址
        goEditAddress(item) {
            this["SET_ELE_EDIT_ADDRESS"](item);
            this.$router.push("/ele/addAddress?edit=true");
        },
        // 选中地址
        chooseAddress(item) {
            if (this.thirdUserId) {
                this.goEle(item);
            } else {
                this["SET_ELE_ADDRESS"](item);
                if (!this.submit) {
                    this["ELE_REFRESH"](true);
                }
                this.goBack();
            }
        },
        goEle(item) {
            new Promise((resolve, reject) => {
                let params = {
                    addressId: item.addressId,
                    itemId: this.eventData.itemId,
                    callBackUrl: this.$route.query.callBackUrl
                };
                if(['roche'].includes(this.eventData.tenant_code)){
                    params.SourceCode = 'ELE'
                }
                if(!params.itemId){
                    params.itemId = this.iStorage.get("eventData").itemId
                }
                miceService.chooseAddress(params).then((res) => {
                    if (res && res.success) {
                        if (this.source == "1") {
                            window.location.href = res.content;
                        } else {
                            resolve();
                        }
                    }
                });
            }).then(() => {
                let params = {
                    ItemId: this.eventData.itemId,
                    latitude: item.latitude,
                    longitude: item.longitude,
                    building: item.addressName,
                    consigneePhone: item.receiverTel,
                    consigneeName: item.receiverName,
                };
                miceService.newRetail(params).then((res) => {
                    if (res && res.success) {
                        window.location.href = res.content;
                    }
                });
            });
        },
        chooseLocalAdd() {
            if (!this.submit) {
                if (this.eleLocalAdd.addressName) {
                    this["SET_ELE_ADDRESS"](this.eleLocalAdd);
                    this["ELE_REFRESH"](true);
                    this.goBack();
                } else {
                    let _this = this;
                    this.$dialog
                        .confirm({
                            title: "定位失败",
                            message: `1、请确保在系统设置中开启了应用定位服务。\n 2、请确保在代开外卖品类时允许系统定位服务。`,
                            confirmButtonText: "手工搜索",
                            showCancelButton: true,
                            confirmButtonColor: _this.color,
                        })
                        .then(async (action) => {
                            if (action === "confirm") {
                                _this.goAddressMap();
                            }
                        })
                        .catch(() => {});
                }
            }
        },
        // 返回
        goBack() {
            this.$router.back(-1);
        },
        getStyle() {
            let commodityHead = document.getElementsByClassName("ele-header")[0]
                .offsetHeight;
            let addressHead = document.getElementsByClassName(
                "smart-round-head"
            )[0].offsetHeight;
            this.commStyle = {
                top: commodityHead + addressHead + "px",
            };
        },
    },
    async mounted() {
        this.$nextTick(() => {
            this.getStyle();
        });
        if (this.thirdUserId) {
            this.getEleAdd();
        } else {
            this.onLoad();
        }
    },
};
</script>

<style lang="scss">
@import "Address";
</style>